import React, { useRef } from "react";

import * as S from "./styles";

const Happy: React.FC = () => {
  const videoRef = useRef<HTMLVideoElement>(null);
  return (
    <S.Container>
      <S.Wrapper
        className="wow animate__animated animate__fadeIn"
        data-wow-duration="1s"
      >
        <S.Title>
          Foto: Vivi Bacco
          <br />
          Vídeo: Fabricio Barreto <br />
          Edição de moda: Lucas
          <br />
          Boccalão Beleza: Jô Portalupi
        </S.Title>
        <S.Text>
          “Se tem uma coisa que eu gosto a respeito de joias e peças únicas de
          modo geral é quando elas me lembram das verdades mais importantes da
          minha vida” diz Thai de Melo, influenciadora digital que conquistou o
          coração do circuito fashion com seu bom humor e trocadilhos espertos
          nas redes sociais. Não à toa, a coleção T de Tiffany & Co. celebra
          alguns dos valores mais fundamentais que carregamos conosco.
          Redesenhando o icônico “T” da marca, pulseiras, colares, anéis e
          pingentes se desdobram para representar o amor (linha T True), a
          felicidade (T Smile), a força (T1) e a amizade (T for friendship).
        </S.Text>
      </S.Wrapper>
      <S.About className="web">
        <S.HappyGirl
          className="wow animate__animated animate__zoomIn"
          data-wow-duration="1s"
        />
        <S.Wrapper
          className="wow animate__animated animate__fadeIn"
          data-wow-duration="1s"
        >
          <S.Text>
            Nascida em Boa Vista (RR), foi sustentada por esses pilares que Thai
            chegou até Curitiba (PR) e, mais recentemente, explodiu na internet
            para o mundo todo. Hoje, seu perfil no Instagram conta com mais de
            100 mil seguidores de olho em suas publicações divertidas, que
            brincam com o dia a dia de sua família. O marido “Marcelão” e a
            dupla de filhos intitulada por ela “Marcelorenzo” (uma junção de
            Marcelo e Lorenzo) são personagens recorrentes. Formada em
            Jornalismo, ela não mente que adora o sucesso que conquistou fazendo
            piada nos Stories. “Detesto isso de ficar ‘se fazendo’. Não há razão
            para eu colocar ‘roteirista’ ou ‘diretora’ na minha bio. Tá lá:
            famosa. É isso que eu sou”, diz, brincando, antes de explicar que a
            Thai das redes é só uma das suas várias facetas, uma sátira da fama
            pela fama.
          </S.Text>
        </S.Wrapper>
      </S.About>
      <S.Video
        className="wow animate__animated animate__fadeIn"
        data-wow-duration="1s"
      >
        <iframe
          src="https://player.vimeo.com/video/547612762?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
          frameBorder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
          }}
          title="Elle - Tiffany.mp4"
        ></iframe>

        {/* <video ref={videoRef} muted autoPlay loop playsInline>
          <source
            src="https://player.vimeo.com/external/538839073.hd.mp4?s=189bc1c9bd443469a12804d2e2e49fd45f3169ad&profile_id=175&download=1"
            type="video/mp4"
          />
        </video> */}
      </S.Video>
      <S.About className="mobile">
        <S.HappyGirl
          className="wow animate__animated animate__zoomIn"
          data-wow-duration="1s"
        />
        <S.Wrapper
          className="wow animate__animated animate__fadeIn"
          data-wow-duration="1s"
        >
          <S.Text>
            Nascida em Boa Vista (RR), foi sustentada por esses pilares que Thai
            chegou até Curitiba (PR) e, mais recentemente, explodiu na internet
            para o mundo todo. Hoje, seu perfil no Instagram conta com mais de
            100 mil seguidores de olho em suas publicações divertidas, que
            brincam com o dia a dia de sua família. O marido “Marcelão” e a
            dupla de filhos intitulada por ela “Marcelorenzo” (uma junção de
            Marcelo e Lorenzo) são personagens recorrentes. Formada em
            Jornalismo, ela não mente que adora o sucesso que conquistou fazendo
            piada nos Stories. “Detesto isso de ficar ‘se fazendo’. Não há razão
            para eu colocar ‘roteirista’ ou ‘diretora’ na minha bio. Tá lá:
            famosa. É isso que eu sou”, diz, brincando, antes de explicar que a
            Thai das redes é só uma das suas várias facetas, uma sátira da fama
            pela fama.
          </S.Text>
        </S.Wrapper>
      </S.About>
    </S.Container>
  );
};

export default Happy;
